document.addEventListener("DOMContentLoaded", (event) => {
    var storageKey = "smokeAlarmCalculatorResult";

    function getNumberValue(selector) {
        return parseInt($(selector).val()) || 0;
    }

    function buildCalculatorResultData() {
        var step1 = getNumberValue("#step-1");
        var step3 = getNumberValue("#step-3");
        var areBedroomsUsingSameHallway = $("#step-2").is(":checked");
        var step2 = areBedroomsUsingSameHallway ? 1 : step3;
        var step5 = getNumberValue("#step-5");
        var areBedroomsConnectedToOpenSpaces = $("#step-4").is(":checked");
        var step4 = areBedroomsConnectedToOpenSpaces ? step5 : 0;
        var step6 = getNumberValue("#step-6");
        var step7 = getNumberValue("#step-7");
        var totalForStep1 = step1;
        var totalForStep2 = step2;
        var totalForStep4 = step4 > 0 ? step4 : 0;
        var totalForStep6 = 0;
        var resultItems = [];
        var reviewItems = [];

        if(step6 > 1){
            totalForStep6 = step6 - step7;
        }

        var total = totalForStep1 + totalForStep2 + totalForStep4 + totalForStep6;

        resultItems.push(`A minimum of ${total} smoke alarms will be required in your home to meet the Queensland requirements.`);
        resultItems.push(`The ${step1} bedrooms require ${step1} smoke alarm.`);

        if(step2 > 1){
            resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm in each.`);
        }else{
            resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm.`);
        }

        if(step4 > 0){
            resultItems.push(`The ${step4} Living area's, rumpus rooms or open spaces that connect to bedrooms will require one smoke alarm in each.`);
        }

        if(step6 > 1){
            resultItems.push("The level without bedrooms will require one smoke alarm on the most likely path of exit.");
        }

        if(step1 > 0){
            reviewItems.push({
                question: "How many bedrooms are in your home?",
                answer: step1
            });
        }

        if(areBedroomsUsingSameHallway){
            reviewItems.push({
                question: "Do all the bedrooms in your home use the same hallway?",
                answer: "yes"
            });
        }else{
            reviewItems.push({
                question: "Do all the bedrooms in your home use the same hallway?",
                answer: "no"
            });

            if(step2 >= 1){
                reviewItems.push({
                    question: "How many hallways have connecting bedrooms?",
                    answer: step2
                });
            }
        }

        if(step4 > 0){
            reviewItems.push({
                question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
                answer: "yes"
            });
            reviewItems.push({
                question: "How many open spaces connect to your bedrooms and hallways?",
                answer: step4
            });
        }else{
            reviewItems.push({
                question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
                answer: "no"
            });
        }

        if(step6 > 0){
            reviewItems.push({
                question: "How many floors in your home?",
                answer: step6
            });
        }

        if(step7 > 0){
            reviewItems.push({
                question: "How many floors have bedrooms on them?",
                answer: step7
            });
        }

        return {
            total: total,
            resultItems: resultItems,
            reviewItems: reviewItems
        };
    }

    function renderCalculatorResult(data) {
        $("#pack-of-needed").html(data.total);
        $(".total-qunatity").html(data.total);
        $("#result-list").empty();
        $("#review-answers").empty();

        data.resultItems.forEach(function(item) {
            $("#result-list").append($("<li>").text(item));
        });

        data.reviewItems.forEach(function(item) {
            var reviewItem = $("<div>");
            reviewItem.append($("<h4>").text(item.question));
            reviewItem.append($("<p>").text("Your answer: ").append($("<span>").text(item.answer)));
            $("#review-answers").append(reviewItem);
        });

        $("#result").fadeIn(10);
    }

    $("#sac-start-btn").click(function(){
        $("#sac-begin").css({"display":"none"});
        $("#sac-step-1").css({"display":"flex"});
    }); 

    // back buttons start
    $(".back-button").click(function(){
        var currentStep = $(this).attr("data-step-current");
        var prevStep = $(this).attr("data-step-prev");

        $(currentStep).css({"display": "none"});
        $(prevStep).css({"display": "flex"});
    });
    // back buttons end

    // field input check start
    function updateValue(operation) {
        var field_value = $(this).siblings(".field-input").val();
        field_value = parseInt(field_value) || 0;

        // Check for the "minus" operation and ensure the value doesn't go below 0
        if (operation === 'minus') {
            if (field_value > 0) {
                field_value -= 1;
            } else {
                // Show error if value is already 0
                $(".error").addClass("active");
                return; // Stop execution if trying to decrement below 0
            }
        } else if (operation === 'plus') {
            field_value += 1;
            // Remove the error when value is increased above 0
            $(".error").removeClass("active");
        }

        $(this).siblings(".field-input").val(field_value);
        $(this).siblings(".field-display").empty().html(field_value);
    }

    // Event listeners for the buttons
    $(".minus-button").click(function() {
        updateValue.call(this, 'minus');
    });

    $(".plus-button").click(function() {
        updateValue.call(this, 'plus');
    });
    // field input check end

    // field type 2 check start
    $(".yes-button").click(function(){
        $(this).siblings("input").attr('checked', true);

        var nextStep = $(this).siblings("input").attr("data-next-step");
        var currentStep = $(this).siblings("input").attr("data-current-step");

        // $(currentStep).css({"display": "none"});
        // $(nextStep).css({"display": "flex"});

        if(currentStep == "#sac-step-2"){
            $(currentStep).css({"display": "none"});
            $("#sac-step-4").css({"display": "flex"});
        }else{
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "flex"});
        }
    });
    $(".no-button").click(function(){
        $(this).siblings("input").attr('checked', false);

        var nextStep = $(this).siblings("input").attr("data-next-step");
        var currentStep = $(this).siblings("input").attr("data-current-step");

        // $(currentStep).css({"display": "none"});
        // $(nextStep).css({"display": "flex"});

        if(currentStep == "#sac-step-4"){
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "none"});
            $("#sac-step-6").css({"display": "flex"});
        }else{
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "flex"});
        }
    });
    // field type 2 check end

    // next button start
    $(".next-button").click(function(){
        var stepData = $(this).parent().siblings(".field-input").val();
        var nextStep = $(this).attr("data-next-step");
        var currentStep = $(this).attr("data-current-step");

        stepData = parseInt(stepData);

        if(currentStep == "#sac-step-3"){
            if(stepData >= 1){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }else{
                $("#sac-final").css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }else if(currentStep == "#sac-step-6"){
            if(stepData > 1){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }else{
                $("#sac-final").css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }else{
            if(stepData >= 0){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }
    });

    // toggles start
    $(".terms-open-button").click(function(){
        $(".sac-final-info").fadeToggle(300);
    });
    $(".review-answers-button").click(function(){
        $("#review-answers-wrapper").fadeToggle(200);
    });
    $("#install-hard-wired-button").click(function(){
        $("#install-hard-wired-content").fadeToggle(200);
    });
    // toggles end
    // next button end

    // get result start
    $("#sac-end-btn").click(function(){
        if($("#terms-and-conditions").is(":checked")){
            $("#sac-final").css({"display": "none"});
            var resultData = buildCalculatorResultData();
            var resultPageUrl = $("#smoke-alarm-calculator").attr("data-result-url") || "/pages/result";

            try {
                sessionStorage.setItem(storageKey, JSON.stringify(resultData));
                window.location.href = resultPageUrl;
            } catch (error) {
                renderCalculatorResult(resultData);
            }
        }else{
            $(this).siblings(".error").addClass("active");
        }
    });
    // get result end

    // form reset
    $("#reset-button").click(function(){
        window.location.reload();
    });
});
